export default "/images/icons8-china.png?2dc34c0b875f597a87387498f1a04560";